/**
 * Cives Hub Backend Authentication API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface ServizioMensaAnagraficaIscrizioneDTO { 
    /**
     * Id della scuola del servizio frequentata dal figlio.
     */
    scuola_id?: string;
    /**
     * Classe del figlio; null se non ancora assegnata.
     */
    classe?: string;
    /**
     * Sezione del figlio; null se non assegnata.
     */
    sezione?: string;
    /**
     * true se lo studente è sospeso dal servizio.
     */
    sospeso?: boolean;
}

